import { useQuery } from '@tanstack/react-query';
import { TourSchedule } from '../models/Tour.model';
import { getToursSchedule } from '../queries/onboarding';

/**
 * Busca as lives de onboarding do período (`GET /aprovaonboarding/:i/:f`).
 * `enabled` permite não buscar quando o aluno já participou (regra de
 * visibilidade), evitando request desnecessário.
 */
export function useFetchOnboardingSchedule(
  startDate: string,
  endDate: string,
  enabled: boolean
) {
  const { data, isError, error, isSuccess, isPending, refetch } = useQuery<
    TourSchedule[]
  >({
    queryKey: ['fetch-onboarding-schedule', startDate, endDate],
    queryFn: () => getToursSchedule(startDate, endDate),
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    refetch,
  };
}
